module.exports = "<div appInitTheme>\n  <div class=\"container mb-3\">\n    <app-market-banner></app-market-banner>\n  </div>\n<router-outlet name=\"quote-process-content\"></router-outlet>\n</div>"


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/full-page-wrapper/full-page-wrapper.component.html
// module id = ../../../../../src/app/full-page-wrapper/full-page-wrapper.component.html
// module chunks = main